import { findHtmlElement } from '@resources/js/helpers/dom'

export const addCss = (htmlElementOrSelector, styles = {}) => {
	const element = findHtmlElement(htmlElementOrSelector)

	if (!element) throw new Error(`Error in addCss: Such element doesn't exist.`)

	// Застосовуємо стилі до елементу
	Object.assign(element.style, styles)
}
